import { EnrichedCartItem } from '@oe-backend/types';

export type Selectable<T> = T & { isSelected?: boolean };

export interface CartState {
	itemCount: number;
	cart: Selectable<EnrichedCartItem[]>;
	filters: CartFilters[];
}

export interface DateRange {
	startDate: Date;
	endDate: Date;
}

export enum CartOtherFilterEnum {
	MarkedForDeletion = 'MarkedForDeletion',
}

export enum CartOrderTypeFilterEnum {
	ReplacementOrder = 'ReplacementOrder',
	NewOrder = 'NewOrder',
}

export enum CartStateFilterEnum {
	Rejected = 'Rejected',
}
export enum CartTimeFilterEnum {
	Today = 'Today',
	Yesterday = 'Yesterday',
	Last5Days = 'Last5Days',
}
export type CartFilters =
	| CartOtherFilterEnum
	| CartStateFilterEnum
	| CartTimeFilterEnum
	| CartOrderTypeFilterEnum;
